import { render, staticRenderFns } from "./AfDocumentInfo.vue?vue&type=template&id=69504067"
import script from "./AfDocumentInfo.vue?vue&type=script&lang=ts"
export * from "./AfDocumentInfo.vue?vue&type=script&lang=ts"
import style0 from "./AfDocumentInfo.vue?vue&type=style&index=0&id=69504067&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports